<template>
 <div :class="windowClass">
    <v-row no-gutters class="pa-2">
        <v-col cols="12">
          <v-card flat>
             <v-toolbar dense>
                  <v-icon  left color="primary">mdi-file-multiple</v-icon>DAILY SALES AND INVENTORY REPORTS  
                  <v-spacer></v-spacer>
                  <span style="width: 180px;">
                      <v-autocomplete
                        v-model="per_type"
                        prepend-icon="mdi-format-list-checks"
                        label="Report"
                        @change="fulls=[],empties=[]"
                        :items="['Overall', 'Per Salesman']"
                        dense
                        outlined
                        hide-details
                      >
                      </v-autocomplete>
                  </span>
                    <span style="width: 220px;" class="ml-4" v-if="per_type !='Overall'">
                       <v-autocomplete
                        v-model="salesman"
                        prepend-icon="mdi-account"
                        label="Saleman"
                        :items="$store.state.users"
                         item-text="fullname"
                        return-object
                        dense
                        outlined
                        hide-details
                      >
                      </v-autocomplete>
                  </span>
                
                  <span style="width: 270px;" class="ml-4">
                       <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="300px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="from_date +' - '+to_date"
                            label="Date range"
                            prepend-icon="mdi-calendar"
                              dense
                              outlined
                              hide-details
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="from_date" no-title scrollable class="mr-1">  </v-date-picker>
                         <v-date-picker v-model="to_date" no-title scrollable @input="queryReports(),menu = false">  </v-date-picker>
                      </v-menu>

                      
                  </span>
          </v-toolbar>
                <v-row dense no-gutters class="pa-2"> 
                    
                    <v-btn small @click="dlCsv()"><v-icon left>mdi-file-download</v-icon> Download csv</v-btn>
                </v-row>
                <div id="PrintReport2">
                  <div style="overflow-x: scroll;">
                  <table class="print_table3 md-font text-center" id="inventory-table">
                      <tr>
                          <th class="text-left" colspan="8" style="padding: 4px"> REPORT: DAILY SALES AND INVENTORY REPORTS</th>
                          <th class="text-left"  colspan="8" style="padding:4px"> PERIOD COVERED: {{from_date | moment($date_only)}} -TO- {{to_date | moment($date_only)}}</th>
                          
                      </tr>
                      <tr>
                          <th class="text-left" :colspan="code_fulls.length" style="padding: 4px;background: #e0e0e0;"> FULLS CONTENTS</th>
                          
                      </tr>
                      <tr >
                        <td style="background: #eaeaea;">INVOICE</td>
                          <td style="background: #eaeaea;">OUTLET NAME</td>
                          <td style="background: #eaeaea;">ROUTE CODE</td>
                            <td style="background: #eaeaea;" v-for="(product, index) in code_fulls" :key="index+'-code'">
                                  {{product.code}}
                            </td>
                      </tr>
                      <tr v-for="(item, index) in FULLSDATA" :key="index" class="md-font ">
                        <td class="text-left">{{item[0].invoice}}</td>
                        <td class="text-left">{{item[0].trade_name}}</td>
                        <td class="text-left">{{item[0].area_code}}</td>
                          <td v-for="(product, index) in code_fulls" :key="index+'-code-item'">
                                {{get_quantity(item,product.code)}}
                          </td>
                      </tr>

                      <tr >
                        
                          <td style="background: #eaeaea;"></td>
                          <td style="background: #eaeaea;"></td>
                          <td style="background: #eaeaea;"></td>
                           <td style="background: #eaeaea;" v-for="(product, index) in code_fulls" :key="index+'-code-fulls'">
                                       {{$count(sum_qty('fulls',product.code))}}
                          </td>
                      </tr>
                       <tr>
                          <th class="text-left"  :colspan="code_fulls.length" style="padding: 4px;"></th>
                          
                      </tr>
                      <tr>
                          <th class="text-left"  :colspan="code_fulls.length" style="padding: 4px;background: #e0e0e0;"> REFUND EMPTIES</th>
                          
                      </tr>
                      <tr >
                          <td style="background: #eaeaea;">INVOICE</td>
                          <td style="background: #eaeaea;">OUTLET NAME</td>
                          <td style="background: #eaeaea;">ROUTE CODE</td>
                          <td style="background: #eaeaea;" v-for="(product, index) in code_empties" :key="index+'-code-e'">
                            {{product.code}}
                          </td>
                      </tr>
                      <tr v-for="(item, index) in EMPTIESDATA" :key="index + '-item'" class="md-font">
                          <td class="text-left">{{item[0].invoice}}</td>
                        <td class="text-left">{{item[0].trade_name}}</td>
                        <td class="text-left">{{item[0].area_code}}</td>
                          <td v-for="(product, index) in code_empties" :key="index+'-code123-item'">
                                {{get_quantity(item,product.code)}}
                          </td>
                      </tr>

                      <tr >
                          
                          <td style="background: #eaeaea;"></td>
                          <td style="background: #eaeaea;"></td>
                          <td style="background: #eaeaea;"></td>
                          <td  style="background: #eaeaea;" v-for="(product, index) in code_empties" :key="index+'-code-empty'">
                                  {{$count(sum_qty('empties',product.code))}}
                          </td>
                      </tr>
                     
                  </table>
                  </div>
                </div>
            </v-card>
        </v-col>
    </v-row>
</div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
      menu: false,
        search:'',
        from_date:'',
        to_date: '',
        date_range:"",
        salesman:{},
        fulls:[],
        empties:[],
         code_fulls:[],
        code_empties:[],
        per_type:'Overall'
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
            this.SET_MENUS()
          this.GET_USERS()
          this.getCodes()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      FULLSDATA(){
       var invoices= this.$groupBy("invoice")
       return invoices(this.fulls)
        //return this.fulls
      },
      EMPTIESDATA(){
        var invoices= this.$groupBy("invoice")
        return invoices(this.empties)
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn', 'setOverlayLoading']),
      get_quantity(item, code){
         // var arr = type=='fulls'?this.fulls:this.empties
         var sum = item.reduce((res,item)=>{
              if(item.product_code == code) {
                  res +=item.quantity
              }
            return res
          },0)
          return sum?sum:'--' 
      },
      sum_qty(type,code){
          var arr = type=='fulls'?this.fulls:this.empties
         var sum = arr.reduce((res,item)=>{
              if(item.product_code == code) {
                  res +=item.quantity
              }
            return res
          },0)
          return sum 
      },
      queryReports(){
        this.fulls=[]
        this.empties=[]
        if(!this.from_date) {
          this.VA_ALERT('error', "Select start date!")
          return
        } else {
          this.APPLOADER(true, "Loading Reports...")
            this.$http.post("report/qry_daily_sales", {from_date:this.from_date, to_date: this.to_date, salesman: this.$IsNum(this.salesman.id), type: this.per_type}).then(response => {
                  response.data.fulls !=null?this.fulls = response.data.fulls:this.fulls=[]
                response.data.empties !=null?this.empties = response.data.empties:this.empties=[]
                  console.log(response.data.fulls)
                  setTimeout(()=>{this.APPLOADER(false,'')}, 600)
                }).catch(e => {
                  console.log(e.data)
              })
        }
      },
      getCodes(){
          this.code_fulls=[]
          this.code_empties=[]
          this.$http.post("report/product_code", {}).then(response => {
            response.data.fulls !=null?this.code_fulls = response.data.fulls:this.code_fulls=[]
            response.data.empties !=null?this.code_empties = response.data.empties:this.code_empties=[]
          }).catch(e => {
            console.log(e.data)
          })
      },
      dlCsv() {
        var filename = this.per_type=='Per Salesman'?this.salesman.fullname.replace(' ','-'):'Overall'
       this.DownloadToCsv("inventory-table", filename+ this.$moment(this.from_date).format('YY-MMM-DD') + '-to-' + this.$moment(this.to_date).format('YY-MMM-DD'))
    }
    },
  }
</script>